import { Analytics } from "@vercel/analytics/react";
import CookieBanner from '../components/google-tag-manager-gtm-banner';


import dynamic from "next/dynamic";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { isProductDetailPage } from "../utils/product-page";
import { annotateProductDetailTables } from "../utils/product-detail-table-labels";
import "../styles/general.css";
import "../styles/modern-core.css";
import "../styles/modern-quick-links.css";
import "../styles/modern-home.css";
import "../styles/modern-site.css";
import "../styles/modern-blog.css";
import Head from "next/head";

import MainNav from "../components/nav-main";
import Footer from "../components/footer";
import DefaultSeo from "../components/default-seo";
import Script from "next/script";

const LiveChatMount = dynamic(() => import("../components/live-chat-mount"), { ssr: false });

// import Sw from "../public/sw";
// import Manifest from "../public/manifest.json";

function MyApp({ Component, pageProps }) {
  const router = useRouter();
  const productDetail = isProductDetailPage(router.pathname);
  const posterPreload = pageProps?.posterPreload ?? null;
  const posterUrl = pageProps?.posterUrl ?? null;

  useEffect(() => {
    const recordVisit = (url) => {
      const path = String(url || "").split("?")[0].split("#")[0];
      if (!path.startsWith("/") || path === "/" || path === "/staff-visits" || path === "/staff-chat") return;
      fetch("/api/page-visits-log", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ path }),
        keepalive: true,
      }).catch(() => {});
    };
    router.events.on("routeChangeComplete", recordVisit);
    return () => router.events.off("routeChangeComplete", recordVisit);
  }, [router.events]);

  useEffect(() => {
    const leaveSite = () => {
      const path = window.location.pathname;
      if (!path.startsWith("/") || path === "/" || path === "/staff-visits" || path === "/staff-chat") return;
      fetch("/api/page-visits-log", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ path, left: true }),
        keepalive: true,
      }).catch(() => {});
    };
    window.addEventListener("pagehide", leaveSite);
    return () => window.removeEventListener("pagehide", leaveSite);
  }, []);

  useEffect(() => {
    if (!productDetail) return;

    const run = () => annotateProductDetailTables();

    run();
    const t1 = window.setTimeout(run, 100);
    const t2 = window.setTimeout(run, 500);
    router.events?.on?.("routeChangeComplete", run);

    return () => {
      window.clearTimeout(t1);
      window.clearTimeout(t2);
      router.events?.off?.("routeChangeComplete", run);
    };
  }, [productDetail, router.pathname, router.events]);

  // useEffect(() => {
  //   if ("serviceWorker" in navigator) {
  //     window.addEventListener("load", function () {
  //       navigator.serviceWorker.register("/sw.js").then(
  //         function (registration) {
  //           console.log(
  //             "Service Worker registration successful with scope: ",
  //             registration.scope
  //           );
  //         },
  //         function (err) {
  //           console.log("Service Worker registration failed: ", err);
  //         }
  //       );
  //     });
  //   }
  // }, []);

  return (
      <div>
        <div>
          <DefaultSeo />
          <Head>
            {posterPreload ? (
              <>
                <link
                  key="lcp-poster-preload"
                  rel="preload"
                  as="image"
                  href={posterPreload.href}
                  imageSrcSet={posterPreload.imageSrcSet}
                  imageSizes={posterPreload.imageSizes}
                  media="(max-width: 991px)"
                  fetchPriority="high"
                />
                {posterPreload.desktopHref ? (
                  <link
                    key="lcp-poster-preload-desktop"
                    rel="preload"
                    as="image"
                    href={posterPreload.desktopHref}
                    imageSrcSet={posterPreload.desktopSrcSet}
                    imageSizes={posterPreload.desktopSizes}
                    media="(min-width: 992px)"
                    fetchPriority="high"
                  />
                ) : null}
              </>
            ) : posterUrl ? (
              <link
                key="lcp-poster-preload"
                rel="preload"
                as="image"
                href={posterUrl}
                fetchPriority="high"
              />
            ) : null}
            <link rel="manifest" href="/manifest.json" />
            <meta name="theme-color" content="#016698" />

            {/* IOS */}
            <meta name="format-detection" content="telephone=no"></meta>
            <meta name="apple-mobile-web-app-capable" content="yes" />
            <link
              rel="apple-touch-icon"
              sizes="57x57"
              href="/io/icon-57x57.png"
            />
            <link
              rel="apple-touch-icon"
              sizes="60x60"
              href="/io/icon-60x60.png"
            />
            <link
              rel="apple-touch-icon"
              sizes="72x72"
              href="/io/icon-72x72.png"
            />
            <link
              rel="apple-touch-icon"
              sizes="76x76"
              href="/io/icon-76x76.png"
            />
            <link
              rel="apple-touch-icon"
              sizes="114x114"
              href="/io/icon-114x114.png"
            />
            <link
              rel="apple-touch-icon"
              sizes="120x120"
              href="/io/icon-120x120.png"
            />
            <link
              rel="apple-touch-icon"
              sizes="144x144"
              href="/io/icon-144x144.png"
            />
            <link
              rel="apple-touch-icon"
              sizes="152x152"
              href="/io/icon-152x152.png"
            />
            <link
              rel="apple-touch-icon"
              sizes="180x180"
              href="/io/icon-180x180.png"
            />
            <meta
              name="apple-mobile-web-app-title"
              content="Technical Union"
            ></meta>
            <meta
              name="apple-mobile-web-app-status-bar-style"
              content="black"
            ></meta>

            {/* ANDROID */}
            <meta name="mobile-web-app-capable" content="yes" />
            <link
              rel="icon"
              type="image/png"
              sizes="16x16"
              href="/android/icon-16x16.png"
            />
            <link
              rel="icon"
              type="image/png"
              sizes="32x32"
              href="/android/icon-32x32.png"
            />
            <link
              rel="icon"
              type="image/png"
              sizes="96x96"
              href="/android/icon-96x96.png"
            />
            <link
              rel="icon"
              type="image/png"
              sizes="192x192"
              href="/android/icon-192x192.png"
            />

          </Head>
        </div>
        
        <nav>
          <MainNav />
        </nav>
        <main
          className={
            productDetail ? "tu-main tu-main--product-detail" : "tu-main"
          }
        >
          <Component {...pageProps} />
        </main>
        <Analytics />
        <div>
          <CookieBanner />
          <LiveChatMount />
        </div>
        <footer>
          <Footer />
        </footer>
      </div>
  );
}

export default MyApp;
